<template>
  <div :class="$style.style">
    <div class="content">
      <div class="mark">
        <img width="197" height="98" src="//img1.jianyewy.com/a93623660fa443e00a6a2fbbf3578635.png" alt="空白" />
      </div>
      <h3 class="title">Oops!</h3>
      <div class="describe">{{msg}}</div>
    </div>
    <!-- <div class="footer">
      <a class="button default" @click="reload()">重新加载</a>
    </div> -->
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  data(){
    return{
      msg:'not found'
    }
  },
  created(){
    if(this.$route.query.errorMsg){
      this.msg=this.$route.query.errorMsg;
    }
  },
  mounted() {
    document.querySelector('.saas-menu').style.display = 'none';
    document.querySelector('.saas-tree').style.display = 'none';
    document.querySelector('.saas-tabs').style.display = 'none';    
  },
  beforeDestroy() {
    document.querySelector('.saas-menu').style.display = 'block';
    document.querySelector('.saas-tree').style.display = 'block';
    document.querySelector('.saas-tabs').style.display = 'block';    
  },
  methods: {
    reload() {
      location.reload();
    }
  }
};
</script>
<style lang="less" module>
:local(.style) {
  .content,
  .footer {
    margin-top: 50px;
    text-align: center;
    color: #000;
  }
}
</style>

